import React from 'react';
import classnames from 'classnames';
import FollowerRange from '@gp/components/FollowerRange';
import AutoTextarea from '@gp/components/AutoTextareaNew';
import OperationBtns from '@gp/components/OperationBtns';
// import { RISK_TYPES } from '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/constants';
import { RATING_OPT } from '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/components/UpdateProjectEditForm/constants';
import { getActionItemCategoryOptions } from '@gp/pages/Pipeline/utils';
import type { IBaseProps } from '@home/types/common';
import type { IRecord } from '@gp/types/global';

import './item.scss';

interface IRiskProps extends IBaseProps {
  index: number;
  isShowDelete?: boolean;
  isShowAdd?: boolean;
  data?: IRecord | null;
  onAdd?: () => void;
  onDelete?: () => void;
  onChange?: (payload: IRecord) => void;
}

const Risk: React.FC<IRiskProps> = (props) => {
  const {
    style,
    className,
    index,
    isShowDelete = false,
    isShowAdd = false,
    data,
    onAdd,
    onDelete,
    onChange,
    actionItemCategory,
  } = props;
  const { category, rating, comment } = data || {};
  const isCategoryValid = !!category;
  const isRatingValid = !!rating;
  const isRiskValid = isCategoryValid && isRatingValid;

  return (
    <div
      style={style}
      className={classnames('dbg-edit-form-box-item', className, { 'dbg-is-error': !isRiskValid })}
    >
      <div className="dbg-edit-form-box-label">Risk {index + 1}</div>
      <div className="dbg-edit-form-box-content">
        <FollowerRange
          className={classnames({ 'dbg-is-error': !isCategoryValid })}
          label="Category"
          placeholder="Please select"
          customizePlaceholder="Please input Risks name"
          // options={RISK_TYPES}
          options={getActionItemCategoryOptions(actionItemCategory)}
          value={category}
          onChange={(value) => {
            onChange?.({ category: value });
          }}
        />
        <div className="dbg-update-edit-divider">-</div>
        <FollowerRange
          className={classnames({ 'dbg-is-error': !isRatingValid })}
          boxClassName="dbg-edit-form-source-selector-box"
          matchButtonWidth
          label="Rating"
          placeholder="Please select"
          isCustomize={false}
          options={RATING_OPT}
          value={rating}
          onChange={(value) => {
            onChange?.({ rating: value });
          }}
        />
        <div className="dbg-edit-form-box-flex">
          <AutoTextarea
            className="dbg-update-edit-textarea"
            placeholder="Please input Risk information"
            value={comment}
            onChange={(value) => {
              onChange?.({ comment: value });
            }}
          />
          {/* 操作按钮 */}
          <OperationBtns
            className="dbg-update-project-edit-operate"
            isShowDelete={isShowDelete}
            isShowAdd={isShowAdd}
            onAdd={onAdd}
            onDelete={onDelete}
          />
        </div>
      </div>
    </div>
  );
};

export default Risk;
